export default {
  AssetDowntime: 'assetDowntime',
  ProductionDowntime: 'productionDowntime',
}
